import { useQuery } from '@tanstack/react-query';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { Skeleton, Table } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { getPayrollValueBandsCooperatorEntries } from '../../../../services/repository/dashboardRepository';
import LoadError from '../LoadError';

const COLUMNS = [
  { title: 'Código', dataIndex: 'codigo', key: 'codigo' },
  { title: 'Descrição do Lançamento', dataIndex: 'descricao', key: 'descricao' },
  {
    title: 'Créditos',
    dataIndex: 'valorCredito',
    key: 'valorCredito',
    align: 'right',
    render: (value) => moneyFormat(value),
  },
  {
    title: 'Débitos',
    dataIndex: 'valorDebito',
    key: 'valorDebito',
    align: 'right',
    render: (value) => moneyFormat(value),
  },
];

function CooperatorEntriesDetail({ cpf, competencia, folhaIds }) {
  const { data, isPending, isError, error, refetch } = useQuery({
    queryKey: ['payroll-value-bands-cooperator-entries', folhaIds, competencia, cpf],
    queryFn: () => getPayrollValueBandsCooperatorEntries({ folhaIds, competencia, cpf }),
  });

  if (isError) {
    return (
      <LoadError
        error={error}
        onRetry={refetch}
      />
    );
  }

  return (
    <Skeleton
      active
      loading={isPending}
    >
      <Table
        columns={COLUMNS}
        dataSource={data?.lancamentos ?? []}
        rowKey="codigo"
        pagination={false}
        size="small"
        summary={() => (
          <>
            <Table.Summary.Row>
              <Table.Summary.Cell
                index={0}
                colSpan={2}
              >
                <strong>Total de Créditos e Débitos</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell
                index={2}
                align="right"
              >
                <strong>{moneyFormat(data?.totalCreditos ?? 0)}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell
                index={3}
                align="right"
              >
                <strong>{moneyFormat(data?.totalDebitos ?? 0)}</strong>
              </Table.Summary.Cell>
            </Table.Summary.Row>
            <Table.Summary.Row>
              <Table.Summary.Cell
                index={0}
                colSpan={3}
              >
                <strong>Total Líquido</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell
                index={3}
                align="right"
              >
                <strong>{moneyFormat(data?.totalLiquido ?? 0)}</strong>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </>
        )}
      />
    </Skeleton>
  );
}

CooperatorEntriesDetail.propTypes = {
  cpf: PropTypes.string.isRequired,
  competencia: PropTypes.string.isRequired,
  folhaIds: PropTypes.arrayOf(PropTypes.number),
};

CooperatorEntriesDetail.defaultProps = {
  folhaIds: undefined,
};

export default CooperatorEntriesDetail;
